export { default as WarehouseListTemplate } from './WarehouseListTemplate';
export { default as WarehouseEditTemplate } from './WarehouseEditTemplate';



// WEBPACK FOOTER //
// ./src/themes/default/modules/warehouse/pages/index.js